export default __webpack_public_path__ + "static/shutdown-banner-mobile-196f7e08804be601432aeaa96b96cfd2.png";